import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export function ProviderInitialsAvatar({ name }: { name: string }) {
  return (
    <Avatar className="size-12 shrink-0">
      <AvatarFallback className="bg-primary/5 text-base font-medium text-primary">
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
}

function initials(name: string) {
  const [first = "", last = ""] = name.split(" ");
  return `${first[0] ?? ""}${last[0] ?? ""}`.toUpperCase();
}
